"use client";
import React from "react";

const BannerLabel = () => {
  // Replaced requestAnimationFrame with pure CSS animation for better performance

  const content = [
    { count: "70,000+", label: "Global Alumni" },
    { count: "100+", label: "University Partners" },
    { count: "600+", label: "Employer Collaborations" },
    { count: "1,000+", label: "Students placed in the U.S." },
  ];

  return (
    <>
      {/* Desktop Version */}
      <div className="md:block hidden w-full bg-gradient-to-r from-[#FFF3D6] via-[#A7D3FF] to-[#FFF3D6] overflow-hidden py-2 relative min-h-[44px]">
        <div className="overflow-hidden w-full relative z-10">
          <div
            className="flex gap-16 w-max"
            style={{
              animation: "banner-marquee 30s linear infinite",
              willChange: "transform",
            }}
          >
            {[...content, ...content, ...content].map((item, index) => (
              <div
                key={`desktop-${index}`}
                className="flex items-center gap-2 text-[18px] md:text-[20px] font-semibold text-[#01060B] flex-shrink-0 whitespace-nowrap leading-[28px]"
              >
                <span className="text-[22px] md:text-[24px] font-bold text-[#01060B] leading-[28px]">
                  {item.count}
                </span>
                {item.label}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Mobile Version */}
      <div className="md:hidden block w-full bg-gradient-to-r from-[#FFF3D6] via-[#A7D3FF] to-[#FFF3D6] overflow-hidden py-3 relative min-h-[44px]">
        <div className="overflow-hidden w-full relative z-10">
          <div
            className="flex gap-8 w-max"
            style={{
              animation: "banner-marquee 30s linear infinite",
              willChange: "transform",
            }}
          >
            {[...content, ...content, ...content].map((item, index) => (
              <div
                key={`mobile-${index}`}
                className="flex items-center gap-2 text-[14px] font-semibold text-[#01060B] flex-shrink-0 whitespace-nowrap leading-[20px]"
              >
                <span className="text-[16px] font-bold text-[#01060B] leading-[20px]">
                  {item.count}
                </span>
                {item.label}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default BannerLabel;
